<script>
export default {
  methods: {
    i18nText(texts, name) {
      return texts.find((text) =>
         text.lang == this.$i18n.locale && text.name == name
      ).content
    }
  }
}
</script>
